import Strings from '../../translations/strings';
import facebookImg from '../../img/icons-socials/Facebook.svg';
import instagramImg from '../../img/icons-socials/Instagram.svg';
import youtubeImg from '../../img/icons-socials/Youtube.svg';
import linkedInImg from '../../img/icons-socials/LinkedIn.svg';
import redditImg from '../../img/icons-socials/Reddit.svg';

export const socialsList = [
    {
        img: facebookImg,
        alt: 'Facebook',
        getLink: () => Strings.components.socials.facebookLink,
    },
    {
        img: redditImg,
        alt: 'Reddit',
        getLink: () => Strings.components.socials.redditLink,
    },
    {
        img: youtubeImg,
        alt: 'Youtube',
        getLink: () => Strings.components.socials.youtubeLink,
    },
    {
        img: linkedInImg,
        alt: 'LinkedIn',
        getLink: () => Strings.components.socials.linkedInLink,
    },
    {
        img: instagramImg,
        alt: 'Instagram',
        getLink: () => Strings.components.socials.instagramLink,
    },
];
